import React from 'react';
import { Col, Placeholder, Row, Table } from 'react-bootstrap';

const STATUS_COLUMNS = 4;

const HeadCell = ({ align = 'center' }: { align?: 'start' | 'center' }) => (
    <div className={`d-flex flex-column align-items-${align}`}>
        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm mb-1" />
        <Placeholder className="skeleton skeleton-table-head" />
    </div>
);

export function PlannerListViewSkeleton({
    groups = 2,
    eventsPerGroup = 2,
}: {
    groups?: number;
    eventsPerGroup?: number;
}) {
    return (
        <Table
            className="table-head-bg opacity-1 mt-3 w-max-content w-md-100 placeholder-glow"
            responsive
            aria-hidden="true"
        >
            <thead className="table-head-bg">
                <tr>
                    <th>
                        <HeadCell align="start" />
                    </th>
                    <th>
                        <div className="d-flex justify-content-center">
                            <Placeholder className="skeleton skeleton-table-head" />
                        </div>
                    </th>
                    {Array.from({ length: STATUS_COLUMNS }).map((_, i) => (
                        <th key={i}>
                            <HeadCell />
                        </th>
                    ))}
                    <th aria-label="Actions header" />
                </tr>
            </thead>
            <tbody>
                {Array.from({ length: groups }).map((_, groupIndex) => (
                    <React.Fragment key={groupIndex}>
                        <tr className="text-dark">
                            <td>
                                <div className="d-flex align-items-center">
                                    <Placeholder className="skeleton skeleton-campaign-icon" />
                                    <Placeholder className="skeleton skeleton-table-name ml-1" />
                                </div>
                            </td>
                            <td />
                            {Array.from({ length: STATUS_COLUMNS }).map((_, i) => (
                                <td key={i} className="text-center">
                                    <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm" />
                                </td>
                            ))}
                            <td />
                        </tr>

                        {Array.from({ length: eventsPerGroup }).map((_, eventIndex) => (
                            <tr key={eventIndex}>
                                <td className="pl-5">
                                    <div className="d-flex align-items-center">
                                        <Placeholder className="skeleton skeleton-platform-icon" />
                                        <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide ml-1" />
                                    </div>
                                </td>
                                <td className="text-center">
                                    <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide" />
                                </td>
                                {Array.from({ length: STATUS_COLUMNS }).map((_, i) => (
                                    <td key={i} className="text-center">
                                        <Placeholder className="skeleton skeleton-header-icon" />
                                    </td>
                                ))}
                                <td>
                                    <Placeholder
                                        className="skeleton skeleton-outline-btn d-block"
                                        style={{ width: 50, height: 34 }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
}

export function PlannerOngoingCampaignsSkeleton({ rows = 5 }: { rows?: number }) {
    return (
        <div className="placeholder-glow" aria-hidden="true">
            <div className="bg-muted default-radius p-1 p-md-2">
                <Row className="align-items-md-end">
                    <Col xs={6}>
                        <Placeholder className="skeleton skeleton-number d-block mb-2" />
                        <Placeholder className="skeleton skeleton-stat-label d-block" />
                    </Col>
                    {Array.from({ length: 2 }).map((_, i) => (
                        <Col key={i} xs={3} className="d-flex flex-column align-items-center">
                            <Placeholder className="skeleton skeleton-header-icon mb-1" />
                            <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm" />
                        </Col>
                    ))}
                </Row>
            </div>
            <Row className="mt-2">
                {Array.from({ length: rows }).map((_, i) => (
                    <React.Fragment key={i}>
                        <Col xs={6} className="d-flex align-items-center my-1 px-0 pl-2">
                            <Placeholder className="skeleton skeleton-message-avatar" />
                            <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-wide ml-2" />
                        </Col>
                        {Array.from({ length: 2 }).map((_, j) => (
                            <Col key={j} xs={3} className="px-1 d-flex justify-content-center align-items-center">
                                <Placeholder className="skeleton skeleton-table-cell skeleton-table-cell-sm" />
                            </Col>
                        ))}
                    </React.Fragment>
                ))}
            </Row>
        </div>
    );
}
